export default "__VITE_ASSET__b01decf5__"